/* :host {
  display: block;
} */

@import '../../../node_modules/swiper/swiper-bundle.css';

/* Box sizing rules */
*,
*::before,
*::after {
  box-sizing: border-box;
}

/* Remove default padding and margin */
* {
  padding: 0;
  margin: 0;
}

/* Default anchor tag styling */
a {
  text-decoration: none;
  color: black;
}

a:hover {
  cursor: pointer;
}

/* Body styling */
html,
body {
  position: relative;
  height: 100%;
}

body {
  font-family: 'Balsamiq Sans', cursive, 'Roboto Mono';
  font-size: 1.2rem;
  text-align: justify;
}

.container {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 1rem;
}

.container > div {
  top: 25vh;
  height: 50vh;
}

div.project_content {
  padding-top: 25vh;
  justify-items: center;
  align-items: center;
}

.project_content h1,
h2,
p {
  padding: 0.2rem 1rem;
}

/* Generic sizing*/
.w-6 {
  width: calc((1rem / 4) * 6) !important;
}
.h-6 {
  height: calc((1rem / 4) * 6) !important;
}

/* Swiper container stylng */
.swiper {
  width: 100%;
  height: 100%;
  padding-bottom: 30px;
  &.syn-swiper {
    padding-bottom: 14px;
  }
  @media screen and (max-width: 768px) {
    padding-bottom: 24px;
  }
}

.swiper-slide {
  text-align: center;
  /* Center slide text vertically */
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
  border-radius: 6px;
  background: transparent;
  position: relative;
}

.swiper-slide:hover {
  cursor: pointer;
}
.swiper:hover .syn-next,
.swiper:hover .syn-prev {
  display: flex;
}
.swiper-slide img {
  display: block;
  border-radius: 8px;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.syn-swiper .swiper-slide img {
  border-radius: 0px;
}

.moreInfo {
  position: absolute;
  bottom: 8px;
}

.swiper-button-next:after,
.swiper-button-prev:after {
  content: unset;
}

/* Synapse Swiper Styling ////////////////////////////////////////////////////////////////////////////////////////////////////////////////*/
.swiper-button-next.syn-next,
.swiper-button-prev.syn-prev {
  width: 2em;
  height: 2em;
  z-index: 11;
  top: 50%;
  /* opacity: 0.3; */
}

.swiper-button-next.syn-next {
  background: #ccc;
  border-radius: 50%;
  width: 1.8em;
  height: 1.8em;
  right: 8px;
  display: none;
  opacity: 0.7;
}
.swiper-button-next.syn-next:hover {
  opacity: 0.9;
}
.swiper-button-next.syn-next svg {
  height: 1em;
  width: 1em;
  color: #333;
}
.swiper-button-prev.syn-prev {
  transform: rotate(180deg);
  background: #ccc;
  border-radius: 50%;
  width: 1.8em;
  height: 1.8em;
  left: 8px;
  display: none;
  opacity: 0.7;
}
.swiper-button-prev.syn-prev {
  opacity: 0.9;
}
.swiper-button-prev.syn-prev svg {
  height: 1em;
  width: 1em;
  color: #333;
}

.swiper-pagination.syn-pagination {
  z-index: 10;
  text-align: right;
  width: calc(100%) !important;
  bottom: 0 !important;
}
.swiper-pagination.syn-pagination .swiper-pagination-bullet {
  background: #ccc;
  opacity: 1;
  border-radius: 0px;
  width: 26px;
  height: 4px;
  margin: 0px 3px;
  opacity: 0.7;
}
.swiper-pagination.syn-pagination .swiper-pagination-bullet:hover {
  opacity: 0.9;
}
.swiper-pagination.syn-pagination .swiper-pagination-bullet-active {
  background: #00a826;
}

/* Jackpotcity Swiper Styling /////////////////////////////////////////////////////////////////////////////////////////////////*/
.swiper-button-next,
.swiper-button-prev {
  width: 26px;
  height: 26px;
  bottom: 0;
  top: unset;
  z-index: 11;
  svg {
    height: 0.75em;
    width: 0.75em;
  }
  &.jpc-next {
    border-radius: 0 6px 6px 0;
    right: 0;
  }
  &.jpc-prev {
    border-radius: 0 6px 6px 0;
    transform: rotate(180deg);
    right: 25px !important;
    left: unset;
  }

  &.dark {
    border: solid 1px #383f4e;
    background-color: #1d2129;
    svg {
      fill: #fff;
    }
  }
  &.light {
    border: solid 1px #dae0ed;
    background-color: #fff;
  }
}

.swiper-pagination.jpc-pagination {
  z-index: 10;
  text-align: right;
  width: calc(100% - 60px) !important;
  bottom: 5px !important;
}
.swiper-pagination.jpc-pagination .swiper-pagination-bullet {
  background: rgba(255, 255, 255, 0.5);
  opacity: 1;
}
.swiper-pagination.jpc-pagination .swiper-pagination-bullet-active {
  background-image: linear-gradient(45deg, #2530ac 0%, #3879fb);
}

.autoplay-progress {
  position: absolute;
  display: none;
  right: 8px;
  bottom: 36px;
  z-index: 10;
  width: 40px;
  height: 40px;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 16px;
  font-family: Helvetica, sans-serif;
  &.dark {
    span {
      color: #fff !important;
    }
    svg {
      fill: #201c2b !important;
    }
  }
  &.light {
    span {
      color: black !important;
    }
    svg {
      fill: #fff !important;
    }
  }
  @media screen and (max-width: 768px) {
    width: 32px;
    height: 32px;
    font-size: 14px;
  }
  @media screen and (max-width: 768px) {
    display: flex;
    right: 8px;
  }
}

.autoplay-progress span {
  z-index: 12;
  & .dark {
    color: #fff;
  }
  &.light {
    color: #000;
  }
}

.autoplay-progress svg {
  --progress: 0;
  position: absolute;
  left: 0;
  top: 0px;
  z-index: 10;
  width: 100%;
  height: 100%;
  stroke-width: 4px;
  stroke: rgba(0, 0, 0, 0.6);
  stroke-dashoffset: calc(125.6 * (1 - var(--progress)));
  stroke-dasharray: 125.6;
  transform: rotate(-90deg);
}
